import React from "react";
import { FormattedMessage } from "react-intl";

import { Button } from "../../../../../components/button/Button";
import { Icon } from "../../../../../components/icon/Icon";
import { ProtectionStatus } from "../protectionEditor/protectionEditor.constants";

interface ProtectionEditorDialogActionsProps {
  onToggleAll: (status: ProtectionStatus) => void;
  areAllBlocked: boolean;
  areAllAllowed: boolean;
}

export const ProtectionEditorDialogActions = ({
  onToggleAll,
  areAllBlocked,
  areAllAllowed,
}: ProtectionEditorDialogActionsProps) => {
  return (
    <div className={"list-actions"}>
      <Button
        className="action-section__button"
        color={"secondary"}
        onClick={() => onToggleAll(ProtectionStatus.Blocked)}
        disabled={areAllBlocked}
        size="large"
      >
        <Icon icon={"fa-regular fa-ban color-danger"} />
        <span>
          <FormattedMessage id="block_all" />
        </span>
      </Button>
      <Button
        className="action-section__button"
        color={"secondary"}
        onClick={() => onToggleAll(ProtectionStatus.Allowed)}
        disabled={areAllAllowed}
        size="large"
      >
        <Icon icon={"fa-regular fa-check color-success"} />
        <span>
          <FormattedMessage id="allow_all" />
        </span>
      </Button>
    </div>
  );
};
